export default "__VITE_ASSET__0a60a1a8__"